import { defineComponent as _defineComponent } from 'vue'
import { ref, reactive, onMounted } from "vue";
import { store } from "@/store/store";
import { useRouter } from "vue-router";
import AgsDataService from "@/services/AgsDataService";
import ResponseData from "@/types/ResponseData";
import Loading from "@/components/agsrs/Loading.vue";

import * as bootstrap from "bootstrap";
import Compressor from "compressorjs";


export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {
  expose();

const router = useRouter();
const serialNo = ref("");
const beforeSerialNo = ref("");
const failureText = ref(false);
const file = reactive([]);
const filename = ref("選択されていません");
const url = ref("");
const compressedFile = reactive([]);
const isLoading = ref(false);
const ocrError = ref(false);
const postTieDataValidationError = ref(false);
const vinNo = ref("");
const resultModal = ref("");
const workPattern = ref("");
const yearCode = ref(0);
const day = ref(0);
const postButtonFlag = ref(true);
const selectFileFlag = ref(false);

onMounted(function () {
  getVinNo();
});

const fullWidth2HalfWidth = () => {
  return serialNo.value.replace(/[^ -~。-゜]/g, function(s) {
    return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
  });
}

// 選択画像取得
const selectedFile = (event) => {
  isLoading.value = true;
  ocrError.value = false;
  postTieDataValidationError.value = false;
  selectFileFlag.value = true;
  postButtonFlag.value = true;
  event.preventDefault();
  file.value = event.target.files[0];
  if(file.value){
    url.value = URL.createObjectURL(file.value);
    filename.value = "選択済みです";
    compress(file.value);
  } else {
    url.value = ""
    filename.value = "選択されていません";
    isLoading.value = false;
  }
};

const compress = (file) => {
  const payload: Compressor.Options = {
    quality: 0.7,
    maxWidth: 600,
    maxHeight: 600,
    mimeType: "image/jpeg",
    success(blob: Blob): void {
      compressedFile.value = blob;
      isLoading.value = false;
    },
    error(err: Error): void {
      isLoading.value = false;
      console.log(err.message);
    },
  };
  new Compressor(file, payload);
};

// ファイル送信
const submitPicture = () => {
  isLoading.value = true;
  ocrError.value = false;
  failureText.value = false;
  postTieDataValidationError.value = false;
  document.getElementById("serialNo").classList.remove("border");
  document.getElementById("serialNo").classList.remove("border-danger");
  document.getElementById("serialNo").classList.remove("border-4");
  const formData = new FormData();
  formData.append("image", compressedFile.value);
  AgsDataService.getSerialNoByTextract(formData)
    .then(async (response: ResponseData) => {
      const modal = new bootstrap.Modal(
        document.getElementById("confirmModal")
      );
      serialNo.value = response["data"];
      resultModal.value = "analysis";
      isLoading.value = false;
      modal.show();
    })
    .catch(async (e: Error) => {
      isLoading.value = false;
      ocrError.value = true;
      console.log(e);
    });
};

const submitTieData = () => {
  ocrError.value = false;
  postTieDataValidationError.value = false;
  serialNo.value = fullWidth2HalfWidth();
  serialNo.value = serialNo.value.toUpperCase();
  judgePattern();
  isLoading.value = true;
  failureText.value = false;
  const formData = new FormData();
  formData.append("vinNo", vinNo.value);
  formData.append("serialNo", serialNo.value);
  formData.append("workPattern", workPattern.value);
  if (workPattern.value === "5") {
    failureText.value = true;
    const modal = new bootstrap.Modal(
        document.getElementById("inputErrorModal")
      );
    isLoading.value = false;
    modal.show();
  } else {
    //登録する前に重複するデータがないかDBを参照
    AgsDataService.searchTieData(formData)
      .then(async (response: ResponseData) => {
        if (response.data['result'] === "duplicated"){
          beforeSerialNo.value = response.data['data'].Item['serialNo']
          const modal = new bootstrap.Modal(
            document.getElementById("duplicationModal")
          );
          modal.show();
        isLoading.value = false;
        } else {
          postTieData();
        }
      })
      .catch(async (e: Error) => {
        isLoading.value = false;
        console.log(e);
      });
  }
};

const judgePattern = () => {
  const alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";

  if (alphabet.indexOf(serialNo.value.substr(2, 1)) > -1) {
    yearCode.value = alphabet.indexOf(serialNo.value.substr(2, 1));
    day.value = (yearCode.value + 1) * 366;
  } else {
    yearCode.value = parseInt(serialNo.value.substr(2, 1));
    if (yearCode.value <= 3) {
      day.value = (yearCode.value + 1) * 366;
    } else {
      day.value = (yearCode.value - 9) * 366;
    }
  }
  if (
    isNaN(serialNo.value.substr(0, 2)) ||
    isNaN(serialNo.value.substr(3, 6)) ||
    serialNo.value.length !== 11 ||
    Number(serialNo.value.substr(3,1)) >= 4
  ) {
    workPattern.value = "5";
  } else if (serialNo.value.substr(9, 1) === "B") {
    workPattern.value = "3";
  } else if (serialNo.value.substr(9, 1) === "M") {
    workPattern.value = "4";
  } else if (serialNo.value.substr(9, 1) === "S") {
    if (parseInt(serialNo.value.substr(3, 3)) + day.value < 58) {
      workPattern.value = "4";
    } else if (parseInt(serialNo.value.substr(3, 3)) + day.value < 668) {
      workPattern.value = "3";
    } else if (parseInt(serialNo.value.substr(3, 3)) + day.value < 911) {
      workPattern.value = "2";
    } else {
      workPattern.value = "1";
    }
  } else {
    workPattern.value = "5";
  }
};

const postTieData = () => {
  isLoading.value = true
  const formData = new FormData();
  formData.append("vinNo", vinNo.value);
  formData.append("serialNo", serialNo.value);
  formData.append("workPattern", workPattern.value);
  AgsDataService.postTieData(formData)
  .then(async (response: ResponseData) => {
    store.dispatch("setSerialNo", serialNo.value);
    store.dispatch("setWorkPattern", workPattern.value);
    const modal = new bootstrap.Modal(
      document.getElementById("completeModal")
    );
    isLoading.value = false;
    resultModal.value = "complete";
    modal.show();
  })
  .catch(async (e: Error) => {
    postTieDataValidationError.value = true;
    isLoading.value = false;
    console.log(e);
  });
}

const inputFix = () => {
  failureText.value = true;
  selectFileFlag.value = false;
  postButtonFlag.value = true;
  document.getElementById("serialNo").classList.add("border");
  document.getElementById("serialNo").classList.add("border-danger");
  document.getElementById("serialNo").classList.add("border-4");
};

const validateSerialNo = () => {
  if (serialNo.value.length === 11) {
    postButtonFlag.value = false;
    document.getElementById("serialNo").classList.remove("border");
    document.getElementById("serialNo").classList.remove("border-danger");
    document.getElementById("serialNo").classList.remove("border-4");
  }
};

const getVinNo = () => {
  vinNo.value = store.getters.vinNo;
};

const returnInitialPage = () => {
  router.push("/")
}

const toDisplayWorkPattern = () => {
  router.push("/judgePattern");
}

const __returned__ = { router, serialNo, beforeSerialNo, failureText, file, filename, url, compressedFile, isLoading, ocrError, postTieDataValidationError, vinNo, resultModal, workPattern, yearCode, day, postButtonFlag, selectFileFlag, fullWidth2HalfWidth, selectedFile, compress, submitPicture, submitTieData, judgePattern, postTieData, inputFix, validateSerialNo, getVinNo, returnInitialPage, toDisplayWorkPattern, Loading }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})